/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PianoConfigContainer_auth = {
    readonly integrations: {
        readonly piano: {
            readonly callbackURL: string;
        };
    };
    readonly " $refType": "PianoConfigContainer_auth";
};
export type PianoConfigContainer_auth$data = PianoConfigContainer_auth;
export type PianoConfigContainer_auth$key = {
    readonly " $data"?: PianoConfigContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"PianoConfigContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PianoConfigContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "PianoAuthIntegration",
                    "kind": "LinkedField",
                    "name": "piano",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "callbackURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = '0b8c3c58f77a0d8b3fcc98c03e9471cd';
export default node;
